/**
 * @file ModalSelect2
 */
'use strict'

/**
 * @classname ModalSelect2
 * @classdesc 検索モーダルが立ち上がるときに、「全て」をアクティブにする
 */
export default class ModalSelect2 {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('ModalSelect2.constructor')
		this._$e = $e
		const modalId = this._$e.attr('data-target')
		this._$modal = $(`${modalId}`)
		$e.on('click', () => this.onClick())


		console.log('modalId::' + modalId)

	}

	/**
	 * モーダルクローズ
	 *
	 * @memberof ModalSelect2
	 * @return {undefined}
	 */
	// onClick() {
	// 	console.log('ModalSelect2.onClick')
	// 	this._$e.addClass('active');

	// 	const $inputBtnsGroups = this._$modal.find(".btn-group")

	// 	console.log('inputBtnsGroup:' + $inputBtnsGroups.length)

	// 	//モーダルのボタングループごと
	// 	$inputBtnsGroups.each((idx, group) => {
	// 		const $group = $(group);
	// 		let activebtn = 0;
	// 		console.log('group1：' + $group.length)

	// 		//対象のモーダルで選択されている条件の数
	// 		$group.find("input[type='checkbox']").each((idx, e) => {
	// 			console.log('idx' + idx)
	// 			if($(e).prop("checked")){
	// 				console.log('$(btn)' + $(e))
	// 				activebtn++;
	// 			}
	// 		});
	// 		console.log('activebtn::' + activebtn)
	// 		//何も選択されていなければ「全て」を選択されている状態にする
	// 		if(activebtn === 0) {
	// 			$group.find("input[type='checkbox']").eq(0).click();
	// 			console.log('btn length::' + $group.find("input[type='checkbox']"))
	// 		}
	// 	});

	// }

	onClick() {
		console.log('ModalSelect2.onClick')
		this._$e.addClass('active');

		let activebtn = 0;
		const $inputBtns = this._$modal.find("input[type='checkbox']")

		//対象のモーダルで選択されている条件の数
		$inputBtns.each(function() {
			if($(this).prop("checked")){
				activebtn++;
			}
		});
		//何も選択されていなければ「全て」を選択されている状態にする
		if(activebtn === 0) {
			//$inputBtns.eq(0).prop('checked', true);
			$inputBtns.eq(0).click();
		}
	}
}
